import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from "../../../base/base-component.component";

@Component({
  selector: 'assets-left-menu',
  templateUrl: './assets-left-menu.component.html',
  styleUrls: ['./assets-left-menu.component.css']
})
export class AssetsLeftMenuComponent extends BaseComponent implements OnInit {
  
  constructor(
    translateService: TranslateService) {
    super(translateService);
    this.setTranslateContext('AssetsLeftMenuComponent');
  }

  ngOnInit() {
  }
}
